// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remove-card-border > section .tile .card {
  border: none;
}`, "",{"version":3,"sources":["webpack://./packages/aiand-scenario/frontend/src/pages/admin/register/register.scss"],"names":[],"mappings":"AACE;EACE,YAAA;AAAJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
